import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';

const BRAZE_ALIAS_LABEL = 'jwId';

export type BrazeAliasType = {
	alias_name: string;
	alias_label: string;
};

export enum NotificationSubscriptionType {
	'OPTED_IN' = 'opted_in',
	'SUBSCRIBED' = 'subscribed',
	'UNSUBSCRIBED' = 'unsubscribed',
}

export type BrazeState = {
	aliasId: BrazeAliasType | undefined;
	country: string | undefined;
	language: string | undefined;
	externalId: string | undefined;
	email: string | undefined;
	firstName: string | undefined;
	notificationType: NotificationSubscriptionType | undefined;
	previousExternalId: string | undefined;
};

// STATE
const state = (): BrazeState => ({
	/**
	 * Standard Attributes
	 */
	aliasId: undefined,
	country: undefined,
	language: undefined,
	externalId: undefined,
	email: undefined,
	firstName: undefined,
	notificationType: undefined,
	previousExternalId: undefined,
});

// GETTERS
const getters: GetterTree<BrazeState, any> = {
	isActiveBrazeUser(state, getters, rootState): boolean {
		const { jwId, jwLoginId } = rootState.user;
		const { aliasId, externalId } = state;
		return jwLoginId === externalId || jwId === aliasId;
	},
};

// ACTIONS
const actions: ActionTree<BrazeState, any> = {
	setAliasJwId({ commit }, id) {
		// use Braze alias to save jwId
		commit('SET_ALIAS_JW_ID', id);
	},

	setLanguage({ commit }, language) {
		commit('SET_LANGUAGE', language);
	},

	setCountry({ commit }, country) {
		commit('SET_COUNTRY', country);
	},

	setExternalId({ commit }, id) {
		// use Braze external id to save jwLoginId
		commit('SET_EXTERNAL_ID', id);
	},

	setEmail({ commit }, name) {
		commit('SET_EMAIL', name);
	},

	setFirstName({ commit }, firstName) {
		commit('SET_FIRSTNAME', firstName);
	},

	setNotificationSubscriptionType({ commit }, type) {
		commit('SET_NOTIFICATION_SUBSCRIPTION_TYPE', type);
	},
	setPreviousExternalId({ commit }, id) {
		commit('SET_PREVIOUS_EXTERNAL_ID', id);
	},
};

// MUTATIONS
const mutations: MutationTree<BrazeState> = {
	SET_ALIAS_JW_ID(state, id: string) {
		state.aliasId = { alias_label: BRAZE_ALIAS_LABEL, alias_name: id };
	},
	SET_COUNTRY(state, country: string) {
		state.country = country;
	},
	SET_EXTERNAL_ID(state, id: string) {
		state.externalId = id;
	},
	SET_LANGUAGE(state, language: string) {
		state.language = language;
	},
	SET_EMAIL(state, email: string) {
		state.email = email;
	},
	SET_FIRSTNAME(state, firstName: string) {
		state.firstName = firstName;
	},
	SET_NOTIFICATION_SUBSCRIPTION_TYPE(state, type: NotificationSubscriptionType) {
		state.notificationType = type;
	},
	SET_PREVIOUS_EXTERNAL_ID(state, id: string) {
		state.previousExternalId = id;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<BrazeState, any>;
